// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"warning__container___reKVx","fadein":"warning__fadein___2Isui","content":"warning__content___3vjYT","icon":"warning__icon___3rCr2","icon-multi-line":"warning__icon-multi-line___c35Q2","iconMultiLine":"warning__icon-multi-line___c35Q2"};
    if(module.hot) {
      // 1789347480003
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  